<div class="mb-0 px-3">
  <h5 class="fw-bold mb-0">
    Welcome Back, {{ full_name }}
  </h5>

  <p class="text-secondary text-xxs">
    Here's your portfolio summary.
  </p>
</div>
